module.exports = __webpack_public_path__ + "fonts/WorkSans-Light.6c55d51.ttf";